export const menuProps = {
	autoFocus          : false,
	getContentAnchorEl : null,
	anchorOrigin       : {
		vertical   : 'bottom',
		horizontal : 'left',
	},
	transformOrigin: {
		vertical   : 'top',
		horizontal : 'left',
	},
};

export const buttonStyles = { color: '#636362', marginRight: '12px', cursor: 'pointer', fontSize: '14px' };
export const buttonStylesDisabled = { color: '#636362', marginRight: '12px', fontSize: '14px' };